import { getPurchaseRecordList } from '@/api/domain/organize'
import { useDictParseList } from '@/utils/useUtils'
import { operateMaxShowLength } from '@/store/dict/config'

const INVOICE_STATE = {
  INVOICING: 1,
  INVOICE_SUCCESS: 2,
  INVOICE_FAIL: 3,
}

const PURCHASE_STATE = {
  PROCESSING: 0,
  COMPLETE: 1,
  FAIL: 2,
}
// 1-待支付 2-支付成功 3-支付失败
const PAY_STATE = {
  PENDING: 1,
  SUCCESS: 2,
  FAILED: 3,
}
const purchaseStateList = {
  0: '处理中',
  1: '完成',
  2: '失败',
}

const invoiceTypeList = {
  1: '电子普票',
  2: '电子专票',
}

const invoiceStateList = {
  [INVOICE_STATE.INVOICING]: '开票中',
  [INVOICE_STATE.INVOICE_SUCCESS]: '开票成功',
  [INVOICE_STATE.INVOICE_FAIL]: '开票失败',
}

const payStateList = {
  [PAY_STATE.PENDING]: '待支付',
  [PAY_STATE.SUCCESS]: '支付成功',
  [PAY_STATE.FAILED]: '支付失败',
}

const getConfigData = (vm, downloadInvoiceFile, handlePurchaseInvoice, baseListManagementRef, openPaymentDialog) => {
  return {
    formData: {
      list: [
        {
          el: 'date-picker',
          itemConfig: {
            label: '提交日期',
            prop: 'gmtCreateDate',
          },
        },
        {
          el: 'input',
          itemConfig: {
            label: '企业主体全称',
            prop: 'orgName',
          },
          elConfig: {
            clearable: true,
            placeholder: '请输入企业主体全称',
            maxlength: 50,
            style: {
              width: '230px',
            },
            events: {
              input: (value) => {
                baseListManagementRef.value.setItemData({
                  elConfigKey: 'value', key: 'orgName', data: value,
                })
              },
            },
          },
        },
        {
          el: 'select',
          itemConfig: {
            label: '支付状态',
            prop: 'payState',
          },
          elConfig: {
            options: {
              label: 'label',
              value: 'value',
              list: useDictParseList(payStateList, true),
            },
          },
        },
        {
          el: 'select',
          itemConfig: {
            label: '份额分配状态',
            prop: 'purchaseState',
          },
          elConfig: {
            options: {
              label: 'label',
              value: 'value',
              list: useDictParseList(purchaseStateList, true),
            },
          },
        },
        {
          el: 'select',
          itemConfig: {
            label: '开票状态',
            prop: 'invoiceState',
          },
          elConfig: {
            options: {
              label: 'label',
              value: 'value',
              list: useDictParseList(invoiceStateList, true),
            },
          },
        },
      ],
      customizeReset: () => {
        baseListManagementRef.value.setItemData({
          elConfigKey: 'value', key: 'orgName', data: '',
        })
      },
    },
    tableData: {
      columns: [
        {
          name: 'gmtCreate',
          columnProps: {
            prop: 'gmtCreate',
            label: '提交时间',
          },
        },
        {
          name: 'orgName',
          columnProps: {
            prop: 'orgName',
            label: '企业主体全称',
            width: 120,
          },
        },
        {
          name: 'orgIdCardNum',
          columnProps: {
            prop: 'orgIdCardNum',
            label: '统一社会信用代码',
            width: 140,
          },
        },
        {
          name: 'purchaseQuantity',
          columnProps: {
            prop: 'purchaseQuantity',
            label: '购买份额数',
            width: 110,
          },
        },
        {
          name: 'purchaseAmount',
          columnProps: {
            prop: 'purchaseAmount',
            label: '付款金额',
          },
        },
        {
          name: 'payState',
          columnProps: {
            prop: 'payState',
            label: '支付状态',
          },
          getText: ({ row }) => {
            return payStateList[row.payState] || '--'
          },
        },
        {
          name: 'payTradeId',
          columnProps: {
            prop: 'payTradeId',
            label: '支付订单号',
            width: 110,
          },
        },
        {
          name: 'payTime',
          columnProps: {
            prop: 'payTime',
            label: '支付成功时间',
            width: 120,
          },
        },
        {
          name: 'payerAccount',
          columnProps: {
            prop: 'payerAccount',
            label: '付款方',
          },
        },
        {
          name: 'invoiceType',
          columnProps: {
            prop: 'invoiceType',
            label: '开票类型',
          },
          getText: ({ row }) => {
            return invoiceTypeList[row.invoiceType]
          },
        },
        {
          name: 'purchaseState',
          columnProps: {
            prop: 'purchaseState',
            label: '份额分配状态',
            width: 120,
          },
          getText: ({ row }) => {
            return purchaseStateList[row.purchaseState] || '--'
          },
        },
        {
          name: 'invoiceState',
          columnProps: {
            prop: 'invoiceState',
            label: '开票状态',
          },
          render: ({ row }) => {
            if (row.invoiceState === INVOICE_STATE.FAIL) {
              return vm.$createElement('el-tooltip', {
                props: {
                  placement: 'top',
                },
              }, [
                vm.$createElement('div', {
                  slot: 'content',
                }, row.remark),
                vm.$createElement('span', [
                  invoiceStateList[row.invoiceState],
                  vm.$createElement('i', {
                    class: 'el-icon-question',
                  }),
                ]),
              ])
            }
            return invoiceStateList[row.invoiceState] || '--'
          },
        },
        {
          name: 'expireDate',
          columnProps: {
            prop: 'expireDate',
            label: '份额失效日期',
            width: 120,
          },
        },
        {
          name: 'operate',
          columnProps: {
            label: '操作',
            prop: 'operate',
            fixed: 'right',
            width: 240,
          },
          maxShowLength: operateMaxShowLength,
          getOperateList: ({ row }) => {
            const { payState, invoiceState } = row
            const resultBtn = [
              {
                name: 'to_pay',
                label: '去支付',
                action: () => openPaymentDialog(row),
                permission: payState === PAY_STATE.PENDING && vm.judgePermission('add_purchase_btn'),
              },
              {
                name: 'replay_pay',
                label: '重新支付',
                action: () => openPaymentDialog(row),
                permission: payState === PAY_STATE.FAIL && vm.judgePermission('add_purchase_btn'),
              },
              {
                name: 'purchase_invoice',
                label: '申请开票',
                action: () => handlePurchaseInvoice(row),
                permission: payState === PAY_STATE.SUCCESS && invoiceState === INVOICE_STATE.INVOICE_FAIL && vm.judgePermission('purchase_invoice'),
              },
              {
                name: 'download_invoice',
                label: '下载发票',
                action: () => downloadInvoiceFile(row),
                permission: invoiceState === INVOICE_STATE.INVOICE_SUCCESS && vm.judgePermission('download_invoice'),
              },
            ]
            return resultBtn.filter((i) => i.permission)
          },
          type: 'operate',
        },
      ],
      apiFn: (params) => {
        const [gmtCreateDateFrom = '', gmtCreateDateTo = ''] = params.gmtCreateDate || []
        return getPurchaseRecordList({
          ...params,
          gmtCreateDateFrom,
          gmtCreateDateTo,
        })
      },
    },
    isShowDepartment: false,
  }
}

export { getConfigData, INVOICE_STATE, invoiceTypeList }
